import { render, staticRenderFns } from "./lay-menu.vue?vue&type=template&id=0d4ff2bd&scoped=true"
import script from "./lay-menu.vue?vue&type=script&lang=js"
export * from "./lay-menu.vue?vue&type=script&lang=js"
import style0 from "./lay-menu.vue?vue&type=style&index=0&id=0d4ff2bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ff2bd",
  null
  
)

export default component.exports